"use client";

import { AnimatePresence } from "motion/react";
import NextLink from "next/link";

import { Logo } from "@/components/common/logo";
import { SideMenu } from "@/components/common/side-menu";

import { useHeader, type UseHeaderProps } from "./use-header";
import HeaderNav from "./header-nav";
import { HeaderActions } from "./header-actions";

export type HeaderProps = UseHeaderProps;

function Header(props: HeaderProps) {
  const {
    className,
    styles,
    opened,
    onHandleMenu,
    menu,
    siteName,
    docsMenu,
    sideMenuOpened,
    onHandleOpenSideMenu,
  } = useHeader(props);

  return (
    <header className={styles.base({ className })}>
      <div className={styles.wrapper()}>
        <NextLink href="/" tabIndex={-1} title={siteName} className={styles.logo()}>
          <Logo variant="acqua-dark" />
        </NextLink>

        <HeaderNav
          menu={menu}
          styles={styles}
          onHandleOpenSideMenu={onHandleOpenSideMenu}
          onHandleMenu={onHandleMenu}
        />

        <AnimatePresence>
          {sideMenuOpened && docsMenu && (
            <SideMenu
              data={docsMenu}
              onHandleOpenSideMenu={onHandleOpenSideMenu}
              isMobileMenu
              onHandleMenu={onHandleMenu}
            />
          )}
        </AnimatePresence>

        <HeaderActions styles={styles} opened={opened} onHandleMenu={onHandleMenu} />
      </div>
    </header>
  );
}

export default Header;
